import React, { useEffect, useState } from 'react'
import { followUser, getIsFollowing, unfollowUser } from '../lib/supabase'
import './FollowButton.css'

export default function FollowButton({
  currentUserId,
  targetUserId,
  className = '',
  variant = 'compact',
  onChange
}) {
  const [isFollowing, setIsFollowing] = useState(false)
  const [loading, setLoading] = useState(false)
  const [ready, setReady] = useState(false)
  const [available, setAvailable] = useState(true)

  useEffect(() => {
    let cancelled = false

    if (!currentUserId || !targetUserId || currentUserId === targetUserId) {
      setReady(false)
      return () => {}
    }

    setReady(false)
    setAvailable(true)

    getIsFollowing(currentUserId, targetUserId)
      .then(value => {
        if (cancelled) return
        setIsFollowing(value)
      })
      .catch(err => {
        console.error('Failed to load follow state:', err)
        if (cancelled) return
        setAvailable(false)
      })
      .finally(() => {
        if (!cancelled) setReady(true)
      })

    return () => { cancelled = true }
  }, [currentUserId, targetUserId])

  if (!currentUserId || !targetUserId || currentUserId === targetUserId) return null
  if (!available) return null

  const handleToggle = async () => {
    if (loading || !ready) return
    setLoading(true)
    const nextValue = !isFollowing

    try {
      if (nextValue) {
        await followUser(currentUserId, targetUserId)
      } else {
        await unfollowUser(currentUserId, targetUserId)
      }
      setIsFollowing(nextValue)
      onChange?.(nextValue)
    } catch (err) {
      console.error('Failed to toggle follow:', err)
    } finally {
      setLoading(false)
    }
  }

  const classes = [
    'follow-btn',
    `follow-btn--${variant}`,
    isFollowing ? 'is-following' : '',
    className
  ].filter(Boolean).join(' ')

  return (
    <button
      type="button"
      className={classes}
      onClick={handleToggle}
      disabled={loading || !ready}
    >
      {loading ? '…' : (isFollowing ? 'Following' : 'Follow')}
    </button>
  )
}
